export default "__VITE_ASSET__BW$vWmus__"